/**
 * V2 brand mark — original diamond / speed-square motif.
 * Recreated from design_reference/js/shell.jsx `Logo`. Accent-colored
 * and theme-aware via `var(--accent)`. Do NOT reuse aiea-logo.svg.
 */

import type { CSSProperties } from 'react';

/** Props for the V2 Logo brand mark. */
export interface LogoProps {
  /** Square edge length in px (default 18). */
  size?: number;
  className?: string;
  style?: CSSProperties;
}

/**
 * Renders the theme-aware V2 brand diamond.
 *
 * @param props - Optional size/className/style.
 * @returns The SVG logo element.
 */
export function Logo({ size = 18, className, style }: LogoProps) {
  return (
    <svg
      width={size}
      height={size}
      viewBox="0 0 24 24"
      fill="none"
      className={className}
      style={style}
      aria-hidden="true"
    >
      <rect x="2.5" y="2.5" width="19" height="19" rx="4" stroke="currentColor" strokeOpacity="0" />
      <path
        d="M12 3.2 20.8 12 12 20.8 3.2 12 12 3.2Z"
        stroke="var(--accent)"
        strokeWidth="1.4"
        strokeLinejoin="round"
        opacity="0.55"
      />
      <path d="M12 7.4 16.6 12 12 16.6 7.4 12 12 7.4Z" fill="var(--accent)" opacity="0.92" />
    </svg>
  );
}
